import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Box,
  Checkbox,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Autocomplete,
  Typography,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Tooltip from "@mui/material/Tooltip";

import InfiniteScroll from "react-infinite-scroll-component";
import PrintIcon from "@mui/icons-material/Print";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import Popover from "@mui/material/Popover";
// import AddIcon from '@mui/icons-material/Add';
import {
  freightPayListReports,
  paymentPrint,
} from "../../../Services/Services";
import { useEffect } from "react";
import { create } from "@mui/material/styles/createTransitions";

const FreightPaymentReport = () => {
  const [branchFilter, setBranchFilter] = useState("");
  const [freightIdFilter, setFreightIdFilter] = useState({
    freightId: "",
    created_at: "",
  });
  const [payDateFilter, setPayDateFilter] = useState("");
  const [paymentToFilter, setPaymentToFilter] = useState("");
  const [freightPaymentList, setfreightPayList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const limit = 50;
  const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);



  const fetchFreightpayment = async (
    pageNo = 1,
    activeFilters = freightIdFilter
  ) => {
    const response = await freightPayListReports(pageNo, activeFilters);
    const results = response?.results || [];

    if (pageNo === 1) {
      setfreightPayList(results);
    } else {
      setfreightPayList((prev) => [...prev, ...results]);
    }

    setHasMore(results.length === limit);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchFreightpayment(1, freightIdFilter);
    }, 500);
    return () => clearTimeout(handler);
  }, [freightIdFilter]);

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchFreightpayment(nextPage);
  };
  const handleFilterChange = (key, value) => {
    setFreightIdFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const [openViewModal, setOpenViewModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const handleView = (row) => {
    setSelectedRow(row);
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setSelectedRow(null);
  };

  const handleExportExcel = () => {
    const table = document.getElementById("freight-payment");
    const rows = Array.from(table.querySelectorAll("tr"));
    const ws_data = [];

    rows.forEach((row) => {
      const cells = Array.from(row.querySelectorAll("th, td"));
      const rowData = cells
        .filter((cell) => !cell.classList.contains("no-print"))
        .map((cell) => cell.innerText);
      ws_data.push(rowData);
    });

    const ws = XLSX.utils.aoa_to_sheet(ws_data);

    const colWidths = ws_data[0].map((_, colIndex) => {
      const maxLength = ws_data.reduce((max, row) => {
        const cell = row[colIndex];
        const len = cell ? cell.toString().length : 10;
        return Math.max(max, len);
      }, ws_data[0][colIndex].length);
      return { wch: maxLength + 2 };
    });
    ws["!cols"] = colWidths;

    const blackBorder = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };

    const headerLength = ws_data[0].length;
    for (let c = 0; c < headerLength; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r: 0, c })];
      if (cell) {
        cell.s = {
          fill: { fgColor: { rgb: "FFFF99" } },
          font: { bold: true, color: { rgb: "000000" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: blackBorder,
        };
      }
    }

    for (let r = 1; r < ws_data.length; r++) {
      for (let c = 0; c < headerLength; c++) {
        const cell = ws[XLSX.utils.encode_cell({ r, c })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center", vertical: "center" },
            border: blackBorder,
          };
        }
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FreightPayment");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Freight_Payment_List.xlsx");
  };

  const handlePrintHTML = () => {
    const table = document.getElementById("freight-payment");
    if (!table) return;

    const printContent = table.outerHTML;
    const printWindow = window.open("", "", "width=1000,height=600");

    printWindow.document.write(`
      <html>
      <head>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 0px 20px 0px 20px;
          }
          header {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #333;
          }
          footer {
            position: fixed;
            bottom: 10px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #333;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: center;
            font-size: 12px;
          }
          th {
            background-color: rgba(211, 211, 211, 0.42);
            color: #000;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .no-print {
            display: none;
          }
        </style>
      </head>
      <body>
        <header>SR ENTERPRICES</header>
        <h3 style="text-align: center;">Freight Payment List</h3>
        ${printContent}
        <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() {
              window.close();
            };
          };
        </script>
      </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
  };
  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }
  const handlePrintSingleRow = async (row) => {
    const data = await paymentPrint(row.freight_payment_id);

    const printWindow = window.open("", "", "width=900,height=600");

    row.payments = data[0] ? data[0].payments : [];
    row.freights = data[0] ? data[0].freights : [];

    // Generate additional table with heading and multiple payment entries
    let additionalTableHTML = "";

    if (Array.isArray(row.freights) && row.freights.length > 0) {
      additionalTableHTML += `
    <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
      <thead>
        <tr>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Freight Id</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Truck No</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Load Wt</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Unload Wt </th>
        <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Net Payble</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Date</th>
        </tr>
      </thead>
      <tbody>
  `;

      row.freights.forEach((freight) => {
        additionalTableHTML += `
      <tr>
        <td style="text-align:center;">${freight.freight_id || ""}</td>
                <td style="text-align:center;">${freight.truck_no || ""}</td>
        <td style="text-align:center;">${freight.loading_wt || ""}</td>
        <td style="text-align:center;">${freight.received_wt || ""}</td>
        <td style="text-align:center;">${freight.net_payable || ""}</td>
         <td style="text-align:center;">${formatOnlyDate(freight.created_at) || ""
          }</td>
      </tr>
    `;
      });

      additionalTableHTML += `
      </tbody>
    </table>
  `;
    }

    // If multiple payments exist

    if (Array.isArray(row.payments) && row.payments.length > 0) {
      additionalTableHTML += `
    <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
      <thead>
        <tr>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Paid Amt</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Pay Mode</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">UPI/Cheque No.</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Payment To</th>
        <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Remark</th>
          </tr>
      </thead>
      <tbody>
  `;

      row.payments.forEach((payment) => {
        additionalTableHTML += `
      <tr>
        <td style="text-align:center;">${payment.pay_amount || ""}</td>
        <td style="text-align:center;">${payment.pay_mode || ""}</td>
        <td style="text-align:center;">${payment.upi_check_no || ""}</td>
        <td style="text-align:center;">${payment.payment_to || ""}</td>
         <td style="text-align:center;">${payment.remark || ""}</td>
      </tr>
    `;
      });

      additionalTableHTML += `
      </tbody>
    </table>
  `;
    }

    if (Array.isArray(data) && data.length > 0) {
      additionalTableHTML += `
    <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
      <thead>
        <tr>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Total Amount</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Paid Amount</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Balance Amount</th>
          </tr>
      </thead>
      <tbody>
  `;

      data.forEach((payment) => {
        additionalTableHTML += `
      <tr>
        <td style="text-align:center;">${payment.total_amount.toFixed(2) || ""
          }</td>
        <td style="text-align:center;">${payment.paid_amount.toFixed(2) || ""
          }</td>
        <td style="text-align:center;">${payment.rem_amount.toFixed(2) || ""
          }</td>
      </tr>
    `;
      });

      additionalTableHTML += `
      </tbody>
    </table>
  `;
    }
    printWindow.document.write(`
    <html>
      <head>
        <title>Print Freight Row</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          header {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #333;
          }
          footer {
            position: fixed;
            bottom: 10px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #333;
          }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          td {
            font-size: 14px;
            vertical-align: top;
          }
          th {
            background-color:rgba(211, 211, 211, 0.42);
            font-weight: bold;
          }
          td[style*="background-color"], th[style*="background-color"] {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        </style>
      </head>
      <body>
        <header>SR ENTERPRICES</header>

        <table border="1" style="border: 1px solid black; border-collapse: collapse;" cellpadding="5">
          <tr>
            <td>Ashutosh Ku. Singh</td>
            <td>Payment ID: ${row.freight_payment_id}</td>
        
          </tr>
          <tr>
            <td>Branch Name: ${row.branch_name}</td>
            <td>Payment Date : ${formatOnlyDate(row.created_at)}</td>
         
          </tr>
        </table>

        <br>

      

        <table border="1" style="border-collapse: collapse; width: 100%;" cellpadding="5">
          <tbody>
            ${additionalTableHTML}
          </tbody>
        </table>

        <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>

        <script>
          window.onload = function () {
            window.print();
            window.onafterprint = function () {
              window.close();
            };
          };
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <>
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" mb={2}>

        <TextField
          label="Search by Freight ID"
          size="small"
          value={freightIdFilter.freightId}
          onChange={(e) => handleFilterChange("freightId", e.target.value)}
          sx={{ flex: "1 1 250px",marginTop: -4 }}
        />

        <TextField
          label="Search by Pay Date"
          size="small"
          value={freightIdFilter.created_at}
          onChange={(e) => handleFilterChange("created_at", e.target.value)}
          sx={{ flex: "1 1 250px",marginTop: -4 }}
        />

        <Button
          variant="outlined"
          onClick={handleExportExcel}
          sx={{ minWidth: "40px", height: "40px", padding: 0 ,marginTop: -4}}
        >
          <FileDownloadIcon fontSize="small" />
        </Button>
        <Button
          variant="outlined"
          onClick={handlePrintHTML}
          sx={{ minWidth: "40px", height: "40px", padding: 0,marginTop: -4 }}
        >
          <PrintIcon fontSize="small" />
        </Button>
      </Box>

      {/* Table */}
      <InfiniteScroll
        dataLength={freightPaymentList.length}
        next={fetchMoreData}
        hasMore={hasMore} // boolean to tell if more data is available
        // loader={
        //   <TableRow>
        //     <TableCell colSpan={9} align="center">
        //       Loading...
        //     </TableCell>
        //   </TableRow>
        // }
        scrollableTarget="scrollableDiv"
        scrollThreshold={0.9}
      >
        <TableContainer
          id="scrollableDiv"
          sx={{ maxWidth: "100%", maxHeight: "75vh" }}
        >
          <Table
            stickyHeader
            size="small"
            id="freight-payment"
            sx={{
              minWidth: "100%",
              tableLayout: "auto",
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                padding: "0px 8px",
                fontSize: "0.8125rem",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                  },
                }}
              >
                <TableCell>Sr No.</TableCell>
                <TableCell>Pay Id</TableCell>
                <TableCell>Branch</TableCell>
                <TableCell>Freight ID</TableCell>
                <TableCell>Total Amt</TableCell>
                <TableCell>Paid Amt</TableCell>
                <TableCell>Rem Amount</TableCell>
                <TableCell>Pay Date</TableCell>

                <TableCell
                  align="center"
                  className="no-print"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#fff",
                    zIndex: 1,
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {freightPaymentList
                .filter((row) => {
                  const matchesFreightId = Array.isArray(row.freight_id)
                    ? row.freight_id
                      .join(", ")
                      .includes(freightIdFilter.freightId)
                    : row.freight_id
                      .toString()
                      .includes(freightIdFilter.freightId);

                  const matchesPayDate = formatOnlyDate(
                    row.created_at
                  ).includes(freightIdFilter.created_at);

                  return matchesFreightId && matchesPayDate;
                })

                .map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: row.is_settlement
                        ? "#d4edda" // light green for settled
                        : row.rem_amount < -20
                          ? "#f8d7da" // light red for very negative remaining amount
                          : index % 2 === 0
                            ? "#fafafa"
                            : "#ffffff",
                      "& td": {
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.freight_payment_id}</TableCell>
                    <TableCell>{row.branch_name}</TableCell>
                    <TableCell>
                      {Array.isArray(row.freights) && row.freights.length > 0 ? (
                        <Tooltip
                          arrow
                          placement="top"
                          title={
                            <div
                              style={{
                                maxHeight: "150px", // यहाँ अपनी ज़रूरत के हिसाब से height सेट करें
                                overflowY: "auto",
                              }}
                            >
                              <table
                                style={{
                                  borderCollapse: "collapse",
                                  fontSize: "12px",
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        border: "1px solid white",
                                        padding: "2px 6px",
                                        background: "black",
                                        fontWeight: "bold",
                                        color: "white",
                                      }}
                                    >
                                      Freight ID
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid white",
                                        padding: "2px 6px",
                                        background: "black",
                                        fontWeight: "bold",
                                        color: "white",
                                      }}
                                    >
                                      Truck No
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {row.freights.map((freight, i) => (
                                    <tr key={i}>
                                      <td
                                        style={{
                                          border: "1px solid white",
                                          padding: "2px 6px",
                                        }}
                                      >
                                        {freight.freight_id}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid white",
                                          padding: "2px 6px",
                                        }}
                                      >
                                        {freight.truck_no}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          }
                        >
                          <span style={{ cursor: "pointer" }}>
                            {row.freights[0].freight_id}
                            {row.freights.length > 1 ? " ..." : ""}
                          </span>
                        </Tooltip>
                      ) : (
                        row.freight_id
                      )}
                    </TableCell>


                    <TableCell>{row.total_amount.toFixed(2)}</TableCell>
                    <TableCell>{row.paid_amount.toFixed(2)}</TableCell>
                    <TableCell>{row.rem_amount.toFixed(2)}</TableCell>
                    <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    <TableCell
                      align="center"
                      className="no-print"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                      }}
                    >
                      {/* Eye Icon (View Details) */}
                      <IconButton
                        color="info"
                        size="small"
                        onClick={() => handleView(row)}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>

                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handlePrintSingleRow(row)}
                      >
                        <PrintIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </InfiniteScroll>

      {/*Dialog Box For Eye Icon (View Details) */}
      <Dialog
        open={openViewModal}
        onClose={handleCloseViewModal}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>View Details</DialogTitle>
        <DialogContent dividers>
          {selectedRow ? (
            <>
              <Table
                size="small"
                sx={{
                  border: "1px solid rgba(224, 224, 224, 1)",
                  "& td, & th": {
                    border: "1px solid rgba(224, 224, 224, 1)",
                  },
                }}
              >
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <strong>Branch Name</strong>
                    </TableCell>
                    <TableCell>{selectedRow.branch_name}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Total Amount</strong>
                    </TableCell>
                    <TableCell>{selectedRow.total_amount}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Paid Amount</strong>
                    </TableCell>
                    <TableCell>{selectedRow.paid_amount.toFixed(1)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Remaining Amount</strong>
                    </TableCell>
                    <TableCell>{selectedRow.rem_amount.toFixed(1)}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <br />
              <Table
                size="small"
                sx={{
                  border: "1px solid rgba(224, 224, 224, 1)",
                  "& td, & th": {
                    border: "1px solid rgba(224, 224, 224, 1)",
                  },
                }}
              >
                <TableRow>
                  <TableCell>Pay Amt</TableCell>
                  <TableCell>Pay Mode</TableCell>
                  <TableCell>Payment To</TableCell>
                  <TableCell>Upi/Check No</TableCell>
                </TableRow>
                {selectedRow?.payments?.map((freight, index) => (
                  <TableRow>
                    <TableCell>{freight.pay_amount}</TableCell>
                    <TableCell>{freight.pay_mode}</TableCell>
                    <TableCell>{freight.payment_to}</TableCell>
                    <TableCell>{freight.upi_check_no}</TableCell>
                  </TableRow>
                ))}
              </Table>
            </>
          ) : (
            <Typography>Loading...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewModal}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FreightPaymentReport;
